/**
 * Portal Manta · KbPrompts
 * Extraído de App.jsx v29.3 (via AST)
 */
import React, { useState, useEffect, useMemo, useCallback, Fragment, memo } from 'react';
import { V } from '../../globals.js';
import { KB_PROMPTS } from '../../app-globals.js';

function KbPrompts(){
  return(<div style={{padding:'12px 16px'}}>
    <div style={{marginBottom:12}}>
      <div style={{fontSize:12.5,fontWeight:700,color:V.br2}}>Prompts & Regras — Instruções do Agente</div>
      <div style={{fontSize:10.5,color:V.g5,marginTop:2}}>Templates versionados que orientam como o agente consulta a KB e apresenta respostas · {KB_PROMPTS.filter(p=>p.ativo).length} ativos de {KB_PROMPTS.length}</div>
    </div>
    <div style={{display:'flex',flexDirection:'column',gap:8}}>
      {KB_PROMPTS.map(p=>(<div key={p.id} style={{background:'#fff',border:`1px solid ${V.g2}`,borderRadius:10,padding:'12px 14px',borderLeft:`3px solid ${p.ativo?V.gn:V.g3}`}}>
        <div style={{display:'flex',alignItems:'center',gap:8,marginBottom:6}}>
          <span style={{fontSize:9.5,fontWeight:700,color:V.g4,fontFamily:'monospace'}}>{p.id}</span>
          <span style={{fontSize:11.5,fontWeight:700,color:V.br,flex:1}}>{p.nome}</span>
          <span style={{fontSize:9,color:V.g5,background:V.g1,padding:'1px 6px',borderRadius:3,fontFamily:'monospace'}}>{p.versao}</span>
          <span style={{fontSize:9.5,fontWeight:700,color:p.ativo?V.gn:V.g4,background:p.ativo?V.gnb:V.g1,padding:'2px 8px',borderRadius:10}}>{p.ativo?'● ativo':'○ inativo'}</span>
        </div>
        <div style={{fontSize:10.5,color:V.g7,lineHeight:1.55,marginBottom:6}}>{p.desc}</div>
        <div style={{display:'flex',alignItems:'center',gap:6,fontSize:9.5,color:V.g5}}>
          <span style={{fontWeight:700,color:V.g4}}>Ex.:</span>
          <span style={{fontStyle:'italic'}}>{p.exemplo}</span>
        </div>
      </div>))}
    </div>
    <div style={{marginTop:12,padding:'10px 12px',background:V.g1,borderRadius:8,fontSize:10,color:V.g5,lineHeight:1.5}}>
      <b style={{color:V.br}}>Convenção de versionamento:</b> v{'{'}major{'}'}.{'{'}minor{'}'} — major incrementa com mudança de comportamento, minor com refinamento. Drafts (v0.x) precisam de revisão antes de ir a produção.
    </div>
  </div>);
}

export { KbPrompts };
export default KbPrompts;
